import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Icon from "@/components/icon/Icon";
import { ArrowRight, Sizes } from "@/components/icon/IconList";
import { Button } from "@bookips/solvook-ui-library";
import { styled } from "@mui/material";
// Fixme: 마이페이지 버튼 사용처 확인하기
export const ButtonWithArrow = (param)=>{
    let { iconColor , iconSize , ...props } = param;
    return /*#__PURE__*/ _jsxs(CustomButton, {
        variant: "filledPrimary",
        ...props,
        children: [
            props.children,
            /*#__PURE__*/ _jsx(Icon, {
                icon: ArrowRight,
                size: iconSize || Sizes.small,
                color: iconColor || "#FFFFFF"
            })
        ]
    });
};
const CustomButton = styled(Button)((param)=>{
    let { theme  } = param;
    return {
        padding: "12px 20px",
        gap: "8px"
    };
});
